import { render, staticRenderFns } from "./EditSaturdayWorkingDays.vue?vue&type=template&id=2835346b&scoped=true"
import script from "./EditSaturdayWorkingDays.vue?vue&type=script&lang=js"
export * from "./EditSaturdayWorkingDays.vue?vue&type=script&lang=js"
import style0 from "./EditSaturdayWorkingDays.vue?vue&type=style&index=0&id=2835346b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835346b",
  null
  
)

export default component.exports